import React, { useState, useEffect, Fragment } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import {
  Button,
  Grid,
  Icon,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { fetchData } from "./js/main";

export default function Permission(props) {
  const [currentUser, setCurrentUser] = useState();
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {!currentUser ? (
        <UserTable onUserSetting={(user) => setCurrentUser(user)} />
      ) : (
        <UserSettings
          onUserSetting={() => setCurrentUser(null)}
          user={currentUser}
          pageRoutes={props.pageRoutes}
          menuGroup={props.menuGroup}
        />
      )}
    </div>
  );
}
function UserSettings({ user, menuGroup, pageRoutes, onUserSetting }) {
  const [billers, setBillers] = useState();
  const [pages, setPages] = useState();
  useEffect(() => {
    (async () => {
      let accounts = await fetchData("get", "/v3/account");
      accounts = accounts.result;
      for (const biller of user.billers) {
        const key = accounts.findIndex((j) => j._id === biller._id);
        if (key > -1) {
          accounts[key].selected = true;
        }
      }
      setBillers(accounts);
      if (pageRoutes) {
        let userPages = await fetchData(
          "get",
          "/v3/user/" + user._id + "/page"
        );
        let pages = JSON.parse(JSON.stringify(pageRoutes));
        userPages = userPages.result;
        for (const page of userPages) {
          const key = pages.findIndex((j) => j.path === page.path);
          if (key > -1) {
            pages[key].selected = true;
          }
        }
        setPages(pages);
      }
    })();
  }, [user, pageRoutes]);

  async function selectBill(key) {
    let Billers = JSON.parse(JSON.stringify(billers));
    let { _id, selected } = Billers[key];
    let success = true;
    if (selected === true) {
      const result = await fetchData(
        "delete",
        "/v3/user/" + user._id + "/account/" + _id
      );
      success = result.success;
    } else {
      const result = await fetchData(
        "put",
        "/v3/user/" + user._id + "/account/" + _id
      );
      success = result.success;
    }
    if (success === true) {
      Billers[key].selected = !Billers[key].selected;
      setBillers(Billers);
    }
  }
  async function selectMenu(page) {
    const selected = !page.selected;
    let Pages = JSON.parse(JSON.stringify(pages));
    const key = Pages.findIndex((j) => j.path === page.path);
    Pages[key].selected = selected;
    let body = {
      user_id: user._id,
      path: page.path,
      status: selected === true ? "add" : "delete",
    };
    await fetchData("put", "/v3/user/page", body);
    setPages(Pages);
  }
  return (
    <div>
      <CustomSeparator user={user} onBack={onUserSetting} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <h3 className="bold" style={{ marginBottom: "10px" }}>
            Menu Permission
          </h3>
          <List component={Paper}>
            {menuGroup.map((group, key) => (
              <Fragment key={key}>
                {key > 0 && <Divider />}
                <ListItem sx={{ padding: "4px 15px" }}>
                  <ListItemText>
                    <div style={{ fontSize: "1.1rem" }} className="bold">
                      {group.label}
                    </div>
                  </ListItemText>
                </ListItem>
                {pages &&
                  pages
                    .filter((j) => j.childOf === group.id)
                    .map((page, key) => (
                      <Fragment key={key}>
                        <Divider />
                        <ListItem disablePadding>
                          <ListItemButton
                            sx={{ padding: "4px 15px" }}
                            onClick={() => selectMenu(page)}
                          >
                            <ListItemIcon sx={{ minWidth: "40px" }}>
                              {page.selected === true ? (
                                <Icon color="success">check_circle</Icon>
                              ) : (
                                <Icon>radio_button_unchecked</Icon>
                              )}
                            </ListItemIcon>
                            <ListItemText>
                              <div>{page.label}</div>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Fragment>
                    ))}
              </Fragment>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={6}>
          {billers && (
            <>
              <h3 className="bold" style={{ marginBottom: "10px" }}>
                Billers Permission
              </h3>
              <List component={Paper}>
                {billers.map((biller, key) => (
                  <Fragment key={key}>
                    <ListItem disablePadding>
                      <ListItemButton
                        sx={{ padding: "4px 15px" }}
                        onClick={() => selectBill(key)}
                      >
                        <ListItemIcon sx={{ minWidth: "40px" }}>
                          {biller.selected === true ? (
                            <Icon color="success">check_circle</Icon>
                          ) : (
                            <Icon>radio_button_unchecked</Icon>
                          )}
                        </ListItemIcon>
                        <ListItemText>
                          <div>{biller.biller_name}</div>
                          <div style={{ fontSize: ".7rem", color: "#090" }}>
                            {biller.account_code}
                          </div>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                    {key + 1 < billers.length && <Divider />}
                  </Fragment>
                ))}
              </List>
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

function CustomSeparator({ user, onBack }) {
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      component={Button}
      sx={{ padding: "0px 0px" }}
      onClick={onBack}
    >
      Permission
    </Link>,
    <Typography key="3" component="div" color="text.primary">
      {user.usn}
    </Typography>,
  ];

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}

function UserTable({ onUserSetting }) {
  const [users, setUsers] = useState();
  useEffect(() => {
    (async () => {
      const users = await fetchData("get", "/v3/user");
      setUsers(users);
    })();
  }, []);

  function onEdit(key) {
    let Users = JSON.parse(JSON.stringify(users));
    Users.result[key].edit = !Users.result[key].edit;
    setUsers(Users);
  }
  async function onDelete(key) {
    if (window.confirm("ยืนยันการลบผู้ใช้งาน : " + users.result[key].usn)) {
      const result = await fetchData(
        "delete",
        "/v3/user/" + users.result[key]._id
      );
      let Users = JSON.parse(JSON.stringify(users));
      Users.result = Users.result.filter((j) => j._id !== result._id);
      setUsers(Users);
    }
  }
  async function saveUser(form) {
    const result = await fetchData("put", "/v3/user", form);
    let Users = JSON.parse(JSON.stringify(users));
    if (result) {
      if (form._id) {
        const key = Users.result.findIndex((j) => j._id === form._id);
        if (key > -1) {
          Users.result[key].edit = false;
          Users.result[key].usn = form.usn;
        }
      } else {
        Users.result.unshift(result);
      }
      setUsers(Users);
    } else alert("Error : Bad request");
  }
  return (
    <div>
      {users && (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "100px" }}>No</TableCell>
                <TableCell>Users</TableCell>
                <TableCell sx={{ width: "100px" }}>Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <EditRow user={{ usn: "" }} onSave={saveUser} />
              {users.result.map((user, key) => (
                <Fragment key={key}>
                  {user.edit === true ? (
                    <EditRow
                      user={user}
                      onEdit={() => onEdit(key)}
                      onDelete={() => onDelete(key)}
                      onSave={saveUser}
                    />
                  ) : (
                    <UserRow
                      user={user}
                      no={key + 1}
                      onEdit={() => onEdit(key)}
                      onSelectUser={() => onUserSetting(user)}
                    />
                  )}
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}

function EditRow({ user, onEdit, onDelete, onSave }) {
  const [form, setForm] = useState();
  useEffect(() => {
    setForm(user);
  }, [user]);

  return (
    <TableRow hover>
      <TableCell align="center" className="inputPadding">
        {user._id ? (
          <IconButton
            color="error"
            sx={{ padding: "5px 5px" }}
            onClick={onDelete}
          >
            <Icon>clear</Icon>
          </IconButton>
        ) : (
          <Icon>add</Icon>
        )}
      </TableCell>
      <TableCell className="inputPadding">
        {form && (
          <TextField
            value={form.usn}
            fullWidth
            size="small"
            onChange={(e) => setForm({ ...form, usn: e.target.value })}
          />
        )}
      </TableCell>
      <TableCell align="center" className="inputPadding">
        {user._id && (
          <IconButton
            color="success"
            sx={{ padding: "5px 5px" }}
            onClick={onEdit}
          >
            <Icon>undo</Icon>
          </IconButton>
        )}
        <IconButton
          color="primary"
          sx={{ padding: "5px 5px" }}
          onClick={() => onSave(form)}
        >
          <Icon>save</Icon>
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

function UserRow({ user, no, onEdit, onSelectUser }) {
  return (
    <TableRow hover>
      <TableCell align="center">{no}</TableCell>
      <TableCell>{user.usn}</TableCell>
      <TableCell align="center" className="inputPadding">
        <IconButton
          color="success"
          sx={{ padding: "5px 5px" }}
          onClick={onSelectUser}
        >
          <Icon>settings</Icon>
        </IconButton>
        <IconButton
          color="primary"
          sx={{ padding: "5px 5px" }}
          onClick={onEdit}
        >
          <Icon>edit</Icon>
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
